<template>
  <div id="add-user-modal" class="modal" v-show="modalShown"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2 v-if="isNew && !isDel">新規ユーザーの追加</h2>
        <h2 v-if="!isNew && !isDel">ユーザーの編集</h2>
        <h2 v-if="!isNew && isDel">ユーザーの削除</h2>
      </div>
      <div class="data-area">
        <div v-if="!isDel" class="error_message">{{ errorMessage.text }}</div>
        <ul :class="[isDel ? 'del_st' : '']">
          <li>
            <span class="label">メールアドレス/ログインID</span>
            <input class="user-input" type="text" v-model="mail" v-if="isNew && !isDel" placeholder="メールアドレス/ログインID">
            <input class="user-input" type="text" v-model="editObj.email" v-if="!isNew && !isDel">
            <span v-if="!isNew && isDel">{{ userObj.email }}</span>
          </li>
          <li>
            <span class="label">ユーザーコード</span>
            <input class="user-input" type="text" v-model="userCode" v-if="isNew && !isDel" placeholder="ユーザーコード">
            <input class="user-input" type="text" v-model="editObj.userCode" v-if="!isNew && !isDel">
            <span v-if="!isNew && isDel">{{ userObj.userCode }}</span>
          </li>
          <li>
            <span class="label">名前</span>
            <input class="user-input" type="text" v-model="userLastName" v-if="isNew && !isDel" placeholder="姓">
            <input class="user-input" type="text" v-model="editObj.userLastName" v-if="!isNew && !isDel">
            <span v-if="!isNew && isDel">{{ userObj.userLastName }}</span>
          </li>
          <li>
            <span class="label"></span>
            <input class="user-input" type="text" v-model="userFirstName" v-if="isNew && !isDel" placeholder="名">
            <input class="user-input" type="text" v-model="editObj.userFirstName" v-if="!isNew && !isDel">
            <span v-if="!isNew && isDel">{{ userObj.userFirstName }}</span>
          </li>
          <li>
            <span class="label">名前（カナ）</span>
            <input class="user-input" type="text" v-model="userLastNameKana" v-if="isNew && !isDel" placeholder="姓（カナ）">
            <input class="user-input" type="text" v-model="editObj.userLastNameKana" v-if="!isNew && !isDel">
            <span v-if="!isNew && isDel">{{ userObj.userLastNameKana }}</span>
          </li>
          <li>
            <span class="label"></span>
            <input class="user-input" type="text" v-model="userFirstNameKana" v-if="isNew && !isDel" placeholder="名（カナ）">
            <input class="user-input" type="text" v-model="editObj.userFirstNameKana" v-if="!isNew && !isDel">
            <span v-if="!isNew && isDel">{{ userObj.userFirstNameKana }}</span>
          </li>
          <li>
            <span class="label">ユーザータイプ</span>
            <select v-model="userType" v-if="isNew && !isDel" placeholder="ユーザータイプ" >
              <option v-for="(type,index) in selectUserTypeList" :key="index" :value="type.code">{{type.label}}</option>
            </select>
            <select v-model="editObj.userType" v-if="!isNew && !isDel" :disabled="isDisable">
              <option v-for="(type,index) in selectUserTypeList" :key="index" :value="type.code">{{type.label}}</option>
            </select>
            <span v-if="!isNew && isDel && userObj && Object.keys(userObj).length > 0">{{ userTypeByDel.label }}</span>
          </li>
          <!-- <li>
            <span :class="{ 'aut-label': !isDel, 'aut-del-label': isDel }">オーダー家具権限</span>
            <span :class="{ 'aut-input1': !isDel, 'aut-del-input': isDel }">
              <label>
                <input type="checkbox" v-model="temporaryOrderFurnitureAuthority" :value="1">
                プラン作成者
              </label>
            </span>
          </li>
          <li>
            <span :class="{ 'aut-label': !isDel, 'aut-del-label': isDel }"></span>
            <span :class="{ 'aut-input2': !isDel, 'aut-del-input': isDel }">
              <label>
                <input type="checkbox" v-model="temporaryOrderFurnitureAuthority" :value="2">
                建具組合員割当者
              </label>
            </span>
          </li>
          <li>
            <span :class="{ 'aut-label': !isDel, 'aut-del-label': isDel }"></span>
            <span :class="{ 'aut-input3': !isDel, 'aut-del-input': isDel }">
              <label>
                <input type="checkbox" v-model="temporaryOrderFurnitureAuthority" :value="3">
                現調施工者
              </label>
            </span>
          </li>
          <li>
            <span :class="{ 'aut-label': !isDel, 'aut-del-label': isDel }"></span>
            <span :class="{ 'aut-input4': !isDel, 'aut-del-input': isDel }">
              <label>
                <input type="checkbox" v-model="temporaryOrderFurnitureAuthority" :value="4">
                製造工場
              </label>
            </span>
          </li>
          <li v-if="(!isDel && userType === 'DOMANS_ADMIN') || (!isDel && editObj.userType === 'DOMANS_ADMIN') || (isDel && temporaryOrderFurnitureAuthority.includes('91'))">
            <span :class="{ 'aut-label': !isDel, 'aut-del-label': isDel }"></span>
            <span :class="{ 'aut-input5': !isDel, 'aut-del-input': isDel }">
              <label>
                <input type="checkbox" v-model="temporaryOrderFurnitureAuthority" :value="91">
                システム管理者
              </label>
            </span>
          </li> -->
        </ul>
        <div v-if="isNew && !isDel">※登録すると本人に登録用メールが送られます。</div>
      </div>
      <div v-if="!isDel">
        <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['userEmail'] }}</p>
        <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['userCode'] }}</p>
        <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['lastName'] }}</p>
        <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['firstName'] }}</p>
        <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['lastNameKana'] }}</p>
        <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['firstNameKana'] }}</p>
        <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['userType'] }}</p>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" @click="addUser" v-if="isNew && !isDel">登録</button>
      <button type="button" class="main_btn" @click="updateUser" v-if="!isNew && !isDel">変更</button>
      <button type="button" class="main_btn" @click="delUser" v-if="!isNew && isDel">削除</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  <!-- ローディングモーダル -->
  <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import store from '../../store/index'

import axios from 'axios'
import * as AppUtils from '../../utils/App'
import * as Api from '../../utils/Api'
import {API_URL} from '../../constants/App'
import {USER_TYPE} from '../../constants/Type'
import LoadingModal from '../../components/common/LoadingModal'
export default {
  name: 'addNewUserModal',
  store: store,
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    isNew: Boolean,
    isDel: Boolean,
    userObj: Object
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** メールアドレス */
      mail: null,
      /** 名前 */
      userLastName: null,
      userFirstName: null,
      userLastNameKana: null,
      userFirstNameKana: null,
      /** ユーザータイプ */
      userType: '',
      userTypeList: [
        {code: 'DOMANS_ADMIN', label: 'domans'},
        {code: 'ADMIN', label: '管理担当'},
        {code: 'DEVELOPER', label: '設計担当'},
        {code: 'PLANNER', label: 'プランナー'},
        {code: 'MANUFACTURER', label: '生産担当'},
        {code: 'VISITOR', label: '閲覧者'}
      ],
      /** ユーザーコード */
      userCode: null,
      /** オーダー家具権限 デフォルトで91に設定 */
      userOrderType: '91',
      /** オーダー家具権限をパイプ分けする前に格納する配列 */
      temporaryOrderFurnitureAuthority: [],
      userOrderTypeList: [
        {code: '1', label: 'プラン作成者'},
        {code: '2', label: '建具組合員割当者'},
        {code: '3', label: '現調施工者'},
        {code: '4', label: '製造工場'},
        {code: '91', label: 'システム管理者'}
      ],
      editObj: {
        userLastName: '',
        userLirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        userCode: '',
        // デフォルトで91に設定
        userOrderType: '91'
      },
      /** エラーメッセージ */
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    },
    userObj: function () {
      this.userLastName = this.userObj.userLastName
      this.userFirstName = this.userObj.userFirstName
      this.userLastNameKana = this.userObj.userLastNameKana
      this.userFirstNameKana = this.userObj.userFirstNameKana
      // this.editName = this.userObj.userName
      this.editMail = this.userObj.email
      this.editUserTyp = this.userObj.userType
      this.userCode = this.userObj.userCode
      /** オーダー家具権限 */
      this.userOrderType = this.userObj.userOrderType
    }
    // userType: function (newVal) {
    //   if (newVal === 'DOMANS_ADMIN' && !this.temporaryOrderFurnitureAuthority.includes('91')) {
    //     this.temporaryOrderFurnitureAuthority.push('91')
    //   } else if (newVal !== 'DOMANS_ADMIN' && this.temporaryOrderFurnitureAuthority.includes('91')) {
    //     let index = this.temporaryOrderFurnitureAuthority.indexOf('91')
    //     this.temporaryOrderFurnitureAuthority.splice(index, 1)
    //   }
    // },
    // 'editObj.userType': function (newVal) {
    //   if (newVal === 'DOMANS_ADMIN' && !this.temporaryOrderFurnitureAuthority.includes('91')) {
    //     this.temporaryOrderFurnitureAuthority.push('91')
    //   } else if (newVal !== 'DOMANS_ADMIN' && this.temporaryOrderFurnitureAuthority.includes('91')) {
    //     let index = this.temporaryOrderFurnitureAuthority.indexOf('91')
    //     this.temporaryOrderFurnitureAuthority.splice(index, 1)
    //   }
    // }
  },
  computed: {
    /** ユーザータイプ（削除用） */
    userTypeByDel: function () {
      if (this.userObj && Object.keys(this.userObj).length > 0) {
        let type = Object.values(USER_TYPE).find(d => { if (d.code === this.userObj.userType) return d })
        return type
      }
    },
    /** domans管理者判定 */
    isDomansAdmin: function () {
      const user = AppUtils.getUserInfo()
      return user.userType === USER_TYPE.DOMANS_ADMIN.code
    },
    /** ユーザータイプ編集判定 */
    isDisable: function () {
      return !this.isNew && !this.isDel && !this.isDomansAdmin && this.editObj.userType === USER_TYPE.DOMANS_ADMIN.code
    },
    /** 表示用ユーザー一覧 */
    selectUserTypeList: function () {
      let list = []
      if (!this.isDomansAdmin) {
        list = this.userTypeList.filter(type => type.code !== USER_TYPE.DOMANS_ADMIN.code)
      } else {
        list = this.userTypeList
      }
      return list
    },
    /** オーダー家具タイプ（削除用） */
    userOrderTypeByDel: function () {
      if (this.userObj && Object.keys(this.userObj).length > 0) {
        return this.temporaryOrderFurnitureAuthority.map(code => this.userOrderTypeList.find(orderType => orderType.code === code).label)
      }
    }
  },
  methods: {
    showModal: function () {
      this.editObj = Object.assign({}, this.userObj)
      // if (!this.isNew && !this.isDel) {
      //   this.transferToArray()
      // }
      this.modalShown = true
    },
    onCancel: function () {
      this.modalShown = false
    },
    addUser: function () {
      this.$refs.loadingModalRef.showModal(true)
      // オーダー家具権限をパイプ分けする処理
      // this.userOrderType = this.temporaryOrderFurnitureAuthority.join('|')
      let payload = {
        lastName: this.userLastName,
        firstName: this.userFirstName,
        lastNameKana: this.userLastNameKana,
        firstNameKana: this.userFirstNameKana,
        userEmail: this.mail,
        userType: this.userType,
        userCode: this.userCode,
        userOrderType: this.userOrderType
      }
      this.errorMessage = {}
      this.validateErrorMessages = {}
      axios.post(API_URL.ADMIN + '/add-user', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        this.$store.dispatch('loadUserList')
        this.modalShown = false
        let modalData = {
          messages: ['登録しました。']
        }
        this.errorMessage = {}
        this.validateErrorMessages = {}
        AppUtils.showModal(modalData)
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    updateUser: function () {
      this.$refs.loadingModalRef.showModal(true)
      // オーダー家具権限をパイプ分けする処理
      // this.editObj.userOrderType = this.temporaryOrderFurnitureAuthority.join('|')
      let payload = {
        lastName: this.editObj.userLastName,
        firstName: this.editObj.userFirstName,
        lastNameKana: this.editObj.userLastNameKana,
        firstNameKana: this.editObj.userFirstNameKana,
        userEmail: this.editObj.email,
        userType: this.editObj.userType,
        userId: this.editObj.userId,
        userCode: this.editObj.userCode,
        userOrderType: this.editObj.userOrderType
      }
      axios.post(API_URL.ADMIN + '/update-user', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        this.$store.dispatch('loadUserList')
        this.modalShown = false
        let modalData = {
          messages: ['変更しました。']
        }
        this.errorMessage = {}
        this.validateErrorMessages = {}
        AppUtils.showModal(modalData)
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    delUser: function () {
      let payload = {
        userId: this.userObj.userId
      }
      axios.post(API_URL.ADMIN + '/delete-user', payload
      ).then(response => {
        this.$store.dispatch('loadUserList')
        this.modalShown = false
        let modalData = {
          messages: ['削除しました。']
        }
        AppUtils.showModal(modalData)
      }).catch(error => {
        Api.handleError(error)
      })
    },
    /** 受け取った配列を「|」で区切り文字列変数に格納 */
    addPipeToAuthority: function () {
      this.userOrderType = this.temporaryOrderFurnitureAuthority.join('|')
    },
    /** 「|」で区切った文字列を配列に移す */
    transferToArray: function () {
      if (typeof this.userObj.userOrderType === 'string') {
        this.temporaryOrderFurnitureAuthority = this.userObj.userOrderType.split('|')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.user-input {
  min-width: 170px;
}
.aut-label {
  text-align: left;
  font-weight: bold;
  padding-left: 35px;
  float: left;
}
.aut-del-label {
  min-width: 190px;
  display: inline-block;
  text-align: left;
  font-weight: bold;
}
.aut-input1 {
  min-width: 0px;
  margin-right: 50px;
}
.aut-input2 {
  min-width: 0px;
  margin-left: 135px;
}
.aut-input3 {
  min-width: 0px;
  margin-left: 91px;
}
.aut-input4 {
  min-width: 0px;
  margin-left: 76px;
}
.aut-input5 {
  min-width: 0px;
  margin-left: 120px;
}
.aut-del-input {
  min-width: 0px;
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
select{
  width: 196px;
}
.del_st {
  margin-left: 100px;
  text-align: left;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  margin: 0px 10px 0px 60px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/UserModal.vue